import React from 'react';
import CloseIcon from '@mui/icons-material/Close';

export interface QuickFilter {
  id: string;
  label: string;
  icon?: string;
  iconImage?: string; // Path to image icon
  filters: Array<{
    field: string;
    operator: 'equals' | 'notEquals' | 'contains' | 'range' | 'greaterThan' | 'lessThan' | 'in';
    value: any;
    value2?: any;
  }>;
}

interface QuickFilterChipsProps {
  filters: QuickFilter[];
  onApply: (filter: QuickFilter) => void;
  activeFilters?: string[]; // IDs of active filters
  onRemove?: (filterId: string) => void;
}

export default function QuickFilterChips({
  filters,
  onApply,
  activeFilters = [],
  onRemove,
}: QuickFilterChipsProps) {
  return (
    <div className="flex flex-wrap gap-2 items-center">
      <span className="text-sm font-medium text-gray-600">Quick Filters:</span>
      {filters.map((filter) => {
        const isActive = activeFilters.includes(filter.id);
        
        return (
          <button
            key={filter.id}
            onClick={() => {
              if (isActive && onRemove) {
                onRemove(filter.id);
              } else {
                onApply(filter);
              }
            }}
            className={`
              inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-medium
              transition-all duration-200
              ${isActive
                ? 'bg-purple-600 text-white shadow-md hover:bg-purple-700'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200 border border-gray-300'
              }
            `}
          >
            {filter.iconImage ? (
              <img src={filter.iconImage} alt={filter.label} className="w-5 h-5" />
            ) : filter.icon ? (
              <span className="text-base">{filter.icon}</span>
            ) : null}
            <span>{filter.label}</span>
            {isActive && onRemove && (
              <CloseIcon 
                sx={{ fontSize: 16 }} 
                className="ml-1 hover:bg-purple-700 rounded-full"
              />
            )}
          </button>
        );
      })}
    </div>
  );
}

// Predefined common quick filters for KVS schools
export const COMMON_QUICK_FILTERS: QuickFilter[] = [
  {
    id: 'all',
    label: 'All Schools',
    icon: '🏫',
    filters: []
  },
  {
    id: 'pm-shri',
    label: 'PM SHRI',
    iconImage: '/assets/PMShreeMarker.svg',
    filters: [
      { field: 'isPMShree', operator: 'greaterThan', value: 0 }
    ]
  },
  {
    id: 'non-pm-shri',
    label: 'KV (non PM SHRI)',
    iconImage: '/assets/kvMarker.svg',
    filters: [
      { field: 'isPMShree', operator: 'equals', value: 0 }
    ]
  },
];
